import { type Drug } from 'schema-dts'

import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { productAccessorGetSubstances } from '../../model/productAccessor/productAccessorGetSubstances'
import { productAccessorIsMedicament } from '../../model/productAccessor/productAccessorIsMedicament'
import { productDataAccessorGetPharmaForm } from '../../model/productDataAccessor'

/**
 * Creates Drug schema for medicinal products (primarily for LLM benefit)
 * https://schema.org/Drug
 */
export const getDrugSchema = (
  product: PimProductWithVariantsV1,
): Drug | undefined => {
  if (!productAccessorIsMedicament(product)) {
    return undefined
  }

  const { activeSubstances } = productAccessorGetSubstances(product)

  const activeIngredients = activeSubstances
    .map(({ description }) => description)
    .filter(Boolean)
  const nonProprietaryName = product.active_ingredients

  const dosageForm = productDataAccessorGetPharmaForm(product)

  return {
    '@type': 'Drug',
    activeIngredient:
      activeIngredients.length > 0 ? activeIngredients : nonProprietaryName,
    administrationRoute: product.ifap?.modality,
    dosageForm,
    name: product.name,
    nonProprietaryName,
  }
}
